/* eslint-disable */
var r1 = function () {
  function i(e, t) {
    for (var n = 0; n < t.length; n++) {
      var i = t[n];
      i.enumerable = i.enumerable || !1,
        i.configurable = !0,
        "value" in i && (i.writable = !0),
        Object.defineProperty(e, i.key, i)
    }
  }
  return function (e, t, n) {
    return t && i(e.prototype, t),
      n && i(e, n),
      e
  }
}()

export default r1
